import React from 'react';
import { Container } from '@plone/components';
import { Image } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';
import ContentWide from 'volto-essvoltocomponents/components/Layout/ContentWide';
/* import { RenderBlocks } from '@plone/volto/components'; */

const NewsItemEssView = ({ content }) => {

  return (
    <ContentWide>
      {/* Hero Image */}
      {content?.hero_image?.scales && (
        <Image
          src={flattenToAppURL(content.hero_image.scales.great.download)}
          alt={content.title}
          className="hero-image"
        />
      )}

      {/* Title */}
      <h1 level={1} className="news-title">
        {content.title}
      </h1>

      {/* Short Description */}
      {content?.short_description && (
        <p className="short-description">{content.short_description}</p>
      )}

      {/* Full Description */}
      {content?.full_description && (
        <p className="full-description">{content.full_description}</p>
      )}

      {/* Body */}
      {content?.body && <div className="news-body">{content.body}</div>}
    </ContentWide>
  );
};

export default NewsItemEssView;
